<template>
	<div>
		<div class="upload_toutu_type" v-show="showSelect">
			<div class="select_type">
				<div class="upload_title">
					<p>选个上传的方式</p>
				</div>
				<ul class="upload_type">
					<li class="type_item">
						<div class="type_img my_img">
							<input ref="inputer" type="file" accept="image/*" class="upload-btn" @change="handleFileChange" />
							<img src="//img.58cdn.com.cn/m58/img/my_img.png">
						</div>
						<p>我的照片</p>
					</li>
					<li class="type_item">
						<div class="type_img virtual_img" @click="showVirtualBox">
							<img src="//img.58cdn.com.cn/m58/img/virtual_img.png">
						</div>
						<p>默认头像</p>
					</li>
					<li class="type_item" v-show="user58pic !== ''">
						<div class="type_img" @click="selectUserPic">
							<img :src="user58pic" class="third-img">
						</div>
						<p>58头像</p>
					</li>
				</ul>
			</div>
			<div class="cancel" @click="hidePop">
				<span>取消</span>
			</div>
		</div>
		<div class="virtual" v-show="!showSelect && showVirtual">
			<div class="virtual_toutu">
				<ul class="virtual_toutuList">
					<li class="virtual_item" :class="{selected: index === selectedItem}" @click="chooseVirtual(item, index)" v-for="(item, index) in items"
					    :key="index">
						<img :src="item">
					</li>
				</ul>
			</div>
			<div class="cancel" @click="backSelect">
				<span>返回</span>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
	props: {
		value: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			showSelect: false,
			showVirtual: false,
			selectedItem: '',
			file: '', // 本地图片文件
			items: [
				'//img.58cdn.com.cn/m58/img/man1_126.png',
				'//img.58cdn.com.cn/m58/img/man2_126.png',
				'//img.58cdn.com.cn/m58/img/man3_126.png',
				'//img.58cdn.com.cn/m58/img/man4_126.png',
				'//img.58cdn.com.cn/m58/img/woman1_126.png',
				'//img.58cdn.com.cn/m58/img/woman2_126.png',
				'//img.58cdn.com.cn/m58/img/woman3_126.png',
				'//img.58cdn.com.cn/m58/img/woman4_126.png'
			]
		};
	},
	computed: {
		...mapGetters(['user58pic'])
	},
	watch: {
		value(val) {
			this.showSelect = val;
		}
	},
	methods: {
		hidePop() {
			this.$emit('hidePop');
		},
		selectUserPic() {
			this.$emit('choose58pic', this.user58pic);
		},
		showVirtualBox() {
			this.showSelect = false;
			this.showVirtual = true;
		},
		chooseVirtual(imgUrl, index) {
			if (index !== this.selectedItem) {
				this.selectedItem = index;
				this.$emit('chooseImg', imgUrl);
			}
		},
		backSelect() {
			this.showVirtual = false;
			this.showSelect = true;
		},
		handleFileChange(e) {
			// 选择文件的base64
			// if (typeof e.target === 'undefined') {
			// 	this.file = e[0];
			// } else {
			// 	this.file = e.target.files[0];
			// }

			// 选择文件
			this.file = this.$refs.inputer.files[0];
			if (!this.file) {
				return;
			}

			this.$emit('imgSelect', this.file);
		}
	}
};
</script>
<style lang="scss" scoped>
@import '../../../assets/style/public.scss';
.upload-btn {
	display: block;
	position: absolute;
	opacity: 0;
	filter: alpha(opacity=0);
	width: px2rem(128px);
	height: px2rem(128px);
}

.upload_toutu_type,
.virtual {
	width: 100%;
	height: px2rem(462px);
	font-size: px2rem(28px);
	background: #f4f4f4;
	color: #333;
	p {
		color: #333;
	}
}

.select_type,
.virtual_toutu {
	height: px2rem(356px);
}

.upload_title {
	padding-top: px2rem(52px);
	padding-bottom: px2rem(42px);
	text-align: center;
}

.upload_type {
	display: -webkit-inline-box;
	display: -webkit-inline-flex;
	display: inline-flex;
	width: 100%;
}

.type_item {
	-webkit-box-flex: 1;
	-webkit-flex: 1;
	flex: 1;
	text-align: center;
}

.type_img {
	width: px2rem(128px);
	height: px2rem(128px);
	border-radius: px2rem(128px);
	text-align: center;
	display: block;
	margin: 0 auto px2rem(26px) auto;
}

.my_img {
	background: #ff5252;
	img {
		width: px2rem(66px);
		height: px2rem(46px);
		margin-top: px2rem(40px);
	}
}

.virtual_img {
	background: #ff9c00;
	img {
		width: px2rem(52px);
		height: px2rem(54px);
		margin-top: px2rem(36px);
	}
}

.cancel {
	line-height: px2rem(92px);
	text-align: center;
	background: #fff;
	margin: 0 px2rem(14px);
	border-radius: px2rem(18px);
}

.virtual_toutuList {
	padding-top: px2rem(40px);
	li {
		width: 25%;
		float: left;
		text-align: center;
		position: relative;
		margin-bottom: px2rem(30px);
		img {
			width: px2rem(126px);
			height: px2rem(126px);
		}
	}
	.selected::after {
		content: '';
		background: url(../../../assets/img/checked.png) no-repeat;
		width: px2rem(40px);
		height: px2rem(40px);
		background-size: contain;
		position: absolute;
		bottom: 0;
		right: px2rem(30px);
	}
}

.third-img {
	width: px2rem(128px);
	height: px2rem(128px);
	border-radius: px2rem(128px);
}
</style>



// WEBPACK FOOTER //
// selectBox.vue?2c7a6983